import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";
import { openSearchOverlay } from "../../lib/searchOverlay";

/**
 * Deep-link shim: /search?q= opens the glass search overlay over Home. The
 * URL deliberately doesn't track overlay state — copy-a-search-link retired
 * with the dedicated page. NOTE: defaultPreload "intent" runs beforeLoad on
 * link hover, so nothing in-app may <Link> here (the overlay opens via
 * openSearchOverlay directly); grep before ever adding one back.
 */
export const Route = createFileRoute("/_authed/search")({
  validateSearch: z.object({ q: z.string().default("") }),
  beforeLoad: ({ search }) => {
    openSearchOverlay(search.q);
    throw redirect({ to: "/", replace: true });
  },
});
